<script setup lang="ts">
import DefaultLayout from './default.vue';
</script>

<template>
  <DefaultLayout no-header no-footer>
    <slot />
  </DefaultLayout>
</template>

<style lang="scss" module>
.logo {
  height: 18px;
}
</style>
